import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BrowseProfessors from '../components/BrowseProfessors';
import { motion } from 'framer-motion';

const BrowseProfessorsPage = () => {
    return (
        <div style={{ minHeight: '100vh', background: 'var(--engine-black)', paddingBottom: '10px' }}>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <BrowseProfessors />
            </motion.div>
        </div>
    );
};

export default BrowseProfessorsPage;



